$(document).ready(function () {

    /* ------------------------------ */
    /* force strict mode  */
    /* ------------------------------ */

    "use strict";

    /* ------------------------------ */
    /* global variables  */
    /* ------------------------------ */

    var windowWidth = $(window).width(),
        viewportMeta = $('meta[name="viewport"]'),
        siteName = $('body').attr('data-site'),
        finishedResizing;

    // set window breakpoints variable
    // call by using window.breakpoint.BREAKPOINT_NAME
    window.breakpoints = getBreakpoint();

    /*
    * Html touch class from jquery mobile
    */

    // if ($.mobile.support.touch) {
    //     $('html').addClass('touchevents');
    // } else {
    //     $('html').addClass('noTouchevents');
    // }

    // redesign begin

    $('.js_carTabHeaderHeight h4').matchHeight();

    $('.js_serviceCTAHeader a').on('click', function (e) {
        e.preventDefault();

        var $this = $(this);

        $this.toggleClass('open');

        $this.parent().next().toggleClass('open');

        $this.html('More Info <i class="fa fa-plus" aria-hidden="true"></i>');

        if ($this.hasClass('open')) {
            $this.html('Close <i class="fa fa-times" aria-hidden="true"></i>');
        }
    });

    $('.offerSmallContentWrap h3').matchHeight();

    $('.js_additionalInfoOverlay').mtcOverlay({
        contentClass: 'additionalInfoOverlayWrap'
    });

    stickyServiceCTABar();

    if (windowWidth > window.breakpoints.mobile) {
        $('.mainNavigation').removeAttr('style');
    }
    // redesign end


    $('.js_externalChatBubble').on('click', function (e) {
        e.preventDefault();

        var $this = $(this),
            chat_dealer_site_id = $this.data('chat-dealer-site-id'),
            chat_provider_id = $this.data('chat-provider-id');

        $(this).fadeOut(function () {
            $.getScript('sites/' + siteName + '/livechat/livechat.js', function () {
                liveChat(chat_dealer_site_id, chat_provider_id);
            });
        });
    });

    if ($('.js_financeExampleLink').length) {
        if ($('#financeTable').length) {
            $('.js_financeExampleLink').on('click', function (e) {
                e.preventDefault();
                $('html, body').delay(1000).stop(true, true).animate({
                    scrollTop: $('#financeTable').offset().top
                }, 1000);
            });
        }
    }

    // end of heritage scripts

    loadSVGs();

    paralaxImageChange();

    mobileHomeSearchMove();

    itemSpecialOffers();

    // if ($('.js_carSpinner').length) {
    //     vehicleSpinCheck($('.js_carSpinner').data('vrm'));
    // }

    if ($('.js_largeSet').length) {
        $('.js_largeSet').parents('.gridRow').addClass('scrollOnMobile');
    }

    // removeHorzScrollBar('.js_popularLinksMobile');

    // fuzzyBounceClass();

    // $('.speechBubbleWrap .closeMe').on('click', function() {
    //
    //     var hide_for_session = true;
    //
    //     $.ajax({
    //         type: 'post',
    //         url: '/sites/' + siteName + '/templates/ajax/fuzzy.session.php',
    //         data: hide_for_session
    //     });
    // });


    /* ------------------------------ */
    /* Remove no JS / Hide JS */
    /* ------------------------------ */

    $('html').removeClass('no-js');
    $('.jshideme').hide();

/*
 * Lazy loaded images
 */


    /* ------------------------------ */
    /* AJAX newsletter submit */
    /* ------------------------------ */

    $('.newsletterFormWrap form').on('submit', function(e) {

        // suppress normal submit
        killclick(e);

        // cache form object and serialise all form data
        var formCache = $('.newsletterFormWrap form'),
            data = formCache.serialize(),
            formSend = true;

        // send data to main controller if no form errors
        if(formSend) {

            // add ajax flag so ajax call returns output to script
            data += '&ajax=true';

            $.ajax({
                type: 'post',
                url: '/sites/' + siteName + '/templates/ajax/newsletter.signup.php',
                data: data,
                dataType: 'json',
                success: function(response) {

	                console.log(response);

                    if(response.success) {
                        // send an event to google tracking

                        dataLayer.push({'event': 'Email newsletter signup'});

                        $('.displayMessage').fadeOut('slow', function () {

                            formCache.find('input').attr('disabled', 'disabled');
                            $('.displayMessage').removeClass('errorMessageFull').addClass('successMessageFull');

                            $('.displayMessage').text('You have been successfully subscribed to our newsletter');
                            $('.successMessageFull').fadeIn('slow');

                            setTimeout(function () {
                                $('.displayMessage').fadeOut('slow');
                            }, 5000);

                        });

                    } else {

                        $('.displayMessage').fadeOut('slow', function () {
                            $('.displayMessage').removeClass('successMessageFull').addClass('errorMessageFull');
							if (response.errors.full_name) {
								$('.displayMessage').text(response.errors.full_name);
							} else if (response.errors.email) {
								$('.displayMessage').text(response.errors.email);
							} else if (response.errors.terms_and_conditions) {
								$('.displayMessage').text(response.errors.terms_and_conditions);
							}

                            $('.errorMessageFull').fadeIn('slow');

                            setTimeout(function () {
                                $('.displayMessage').fadeOut('slow');
                            }, 5000);
                        });
                    }
                }
            });
        }
    });

    $('.js_mobileOffersTrigger').on('click', function (e) {
        e.preventDefault();

        var $this = $(this),
            speed = 0,
            scroll_element = '';

        if ($.browser.safari) {
            scroll_element = $('body');
        } else {
            scroll_element = $('html');
        }

        if ($('.mobileNavBlock').hasClass('fixed')) {
            speed = 800;
        }

        scroll_element.stop(true, false).animate({
            scrollTop: 0
        }, speed, function () {
            $this.toggleClass('active');

            if ($('#content #searchFormWrap').is(':visible') && $('.js_scrollToSearch').length === 0) {
                $('#content #searchFormWrap').slideUp(function () {
                    $(this).removeClass('formOpen');
                    $('.js_triggerSearch').removeClass('active');
                    $('.js_offersMenuMobile').stop(true, true).slideDown();
                });
            } else if ($('.flyoutWrap').is(':visible')) {
                $('.flyoutWrap').slideUp(function () {
                    $(this).removeClass('alive');
                    $('.flyout').removeClass('alive');
                    $('.js_offersMenuMobile').stop(true, true).slideDown();
                });
            } else if ($('.searchFilter').is(':visible')) {
                $('.searchFilter').slideUp(function () {
                    $('.js_triggerRefine').removeClass('active');
                    $('.js_offersMenuMobile').stop(true, true).slideDown();
                })
            } else {
                $('.js_offersMenuMobile').stop(true, true).slideToggle();
            }
        });
    });

    /* ------------------------------ */
    /* trigger carousel items  */
    /* ------------------------------ */

    tabsFeaturedItemsCarousel();

    pvFoundationLogosCarousel();

    awardsCarousel();


    /* ------------------------------ */
    /* AJAX forms  */
    /* ------------------------------ */

    // contact form
    if ($('.contactForm').length) {
        submitForm('.contactForm');
    }
    if ($('.memberSignin').length) {
        submitForm('.memberSignin');
    }
    if ($('.registerMember').length) {
        submitForm('.registerMember');
    }
    if ($('.reminder').length) {
        submitForm('.reminder');
    }
    if ($('.resetPassword').length) {
        submitForm('.resetPassword');
    }
    if ($('.js_contactDetails').length) {
        submitForm('.contactDetails');
    }

    if ($('.unsubscribeForm').length) {
        submitForm('.unsubscribeForm');
    }

    if ($('.jobsForm').length) {
        submitIframeForm('.jobsForm');
    }
    if ($('.promiseForm').length) {
        submitIframeForm('.promiseForm');
    }

    if ($('#charityFundingForm').length) {
        submitForm('#charityFundingForm');
    }

    /* ------------------------------ */
    /* Date picker  */
    /* ------------------------------ */

    $('#ppFormPurchaseDate, #ppFormMotExpiry').datepicker({
        dateFormat: "dd/mm/yy",
        changeYear: true
    });

    $('#ppDOB').datepicker({
        dateFormat: "dd/mm/yy",
        changeYear: true,
        yearRange: '1920:2016'
    });

    /* ------------------------------ */
    /* Sorting events on browse page  */
    /* ------------------------------ */

    $('.fdropdown.no-ajax').change(function () {
        var url = $(this).children('option:selected').val();
        window.location.href = url;
    });

    /* ------------------------------ */
    /* Responsive Tables  */
    /* ------------------------------ */

    if ($('table').hasClass('responsive')) {
        mtcResponsiveTables({
            breakpoint: window.breakpoints.mobile
        });
    }

    function responsiveTable($this, icon) {
        if (matchesMediaQuery(0, 640) || matchesMediaQuery(0, 1040)) {

            $this.css({
                overflow: 'hidden'
            });

            icon.fadeIn();

            $this.on('swipe click', function () {
                icon.fadeOut(function () {

                    $this.css({
                        overflow: 'auto'
                    });

                });
            });
        }
    }

    function responsiveTagImage($this, icon) {
        if ($('html').hasClass('touchevents')) {

            $this.css({
                overflow: 'hidden'
            });

            icon.fadeIn();

            $this.on('swipe click', function () {
                icon.fadeOut(function () {

                    $this.css({
                        overflow: 'auto'
                    });

                });
            });
        }
    }

    if ($('.landingPageContent table').length) {

        var swipe_icon_html = '<span class="tableSwipeIcon js_tableSwipeIcon">\n' +
            '<img src="../sites/petervardy/images/svgs/swipe-icon.svg" alt="Swipe to view more">\n' +
            '<span>Swipe to view more</span>\n' +
            '</span>';

        $('.landingPageContent table').each(function () {
            $('.landingPageContent table').wrap('<div class="responsiveTable">');

            $(swipe_icon_html).insertBefore('.responsiveTable table');

            responsiveTable($(this).parent(), $(this).prev('.js_tableSwipeIcon'));
        });
    }

    // $.fn.hasScrollBar = function() {
    //     return this.get(0).scrollWidth > this.get(0).clientWidth;
    // };
    //
    // $('.responsiveTable').each(function () {
    //     if ($(this).hasScrollBar()) {
    //         $(this).addClass('overflowedTable');
    //     } else {
    //         $(this).removeClass('overflowedTable');
    //     }
    // });

    // simple scroll to search on homepage
    if ($('.js_scrollToSearch').length) {
        $('.js_scrollToSearch').on('click', function (e) {
            e.preventDefault();

            if ($('.flyoutWrap').is(':visible')) {
                $('.flyoutWrap').slideUp(function () {
                    $('.flyout').removeClass('alive');

                    $('body, html').delay(300).animate({
                        scrollTop: $('.js_homepageSearchMobile').offset().top - 60
                    }, 800);
                });
            } else if ($('.hasFranchise.subNavigstion').is(':visible')) {
                $('.hasFranchise.subNavigstion').slideUp(function () {
                    $('.flyoutTopMenu').removeClass('alive');

                    $('body, html').delay(300).animate({
                        scrollTop: $('.js_homepageSearchMobile').offset().top - 60
                    }, 800);
                });
            } else if ($('.js_offersMenuMobile').length === 0) {
                $('body, html').delay(300).animate({
                    scrollTop: $('.js_homepageSearchMobile').offset().top - 60
                }, 800);
            } else {
                $('.js_offersMenuMobile').slideUp(function () {
                    $('.js_mobileOffersTrigger').removeClass('active');

                    $('body, html').delay(300).animate({
                        scrollTop: $('.js_homepageSearchMobile').offset().top - 60
                    }, 800);
                });
            }
        });
    }

    $('.flyoutTopMenu').on('click', function () {

        var $this = $(this),
            element_to_close = $('.flyoutWrap');

        // if ($('.searchWrap').is(':visible')) {
        //     element_to_close = $('.searchWrap');
        //     $('.searchWrap').removeClass('formOpen');
        // }

        element_to_close.slideUp(function () {

            $(this).removeClass('alive');
            $('.flyout').removeClass('alive');
            $('.js_triggerSearch').removeClass('active');

            $this.addClass('alive');
            $this.parents('#header').find('.hasFranchise').stop(true, true).slideFadeToggle();
            $this.parents('#header').find('.hasFranchise li').removeClass('open').find('.sub').hide();
            $this.parents('#header').find('.hasFranchise h4').removeClass('open');
            $this.parents('#header').find('.hasFranchise .column ul').hide();
        });
    });

    $('.hasFranchise .megaMenu > a, .hasFranchise .hasChildren > a').on('click', function (e) {
        if (windowWidth <= window.breakpoints.mobile) {
            e.preventDefault();

            var $this = $(this);

            // Prepend parent clone to top of sub nav
            if ($this.parent().find('.clone').length == 0 && !$(this).parents('li').hasClass('megaMenu')){
                var topLevelItem = $(this).clone().addClass('clone');
                topLevelItem.prependTo($(this).parent().find('> .sub').find('ul')).wrap('<li />');
            }

            $this.parents('li').toggleClass('open');
            $this.parents('li').siblings('li').removeClass('open').find('.sub').stop(true, true).slideUp();
            $this.parents('li').find('.sub').stop(true, true).slideToggle();
            $(this).parents('#header').find('.hasFranchise h4').removeClass('open');
            $(this).parents('#header').find('.hasFranchise .column ul').hide();
        }
    });

    $('.hasFranchise .megaMenu h4').on('click', function (e) {
        if (windowWidth <= window.breakpoints.mobile) {
            e.preventDefault();

            var $this = $(this);

            $this.toggleClass('open');
            $this.parents('.column').siblings('.column').find('h4').removeClass('open');
            $this.parents('.column').siblings('.column').find('ul').stop(true, true).slideUp();
            $this.parents('.column').find('ul').stop(true, true).slideToggle();
        }
    });

    /* ------------------------------ */
    /* Trigger Vee24 Live Chat  */
    /* ------------------------------ */

    $('.js_triggerLiveChat').on('click', function() {
        $(".LPMcontainer").click();
    });

    const chatInterval = setInterval(() => {

        if ($('.LPMcontainer').length > 0) {
            $(".chatLoading").removeClass("active");
        }
    }, 1000);

    setTimeout(function() {
        clearInterval(chatInterval);
    },10000);

    /* ------------------------------ */
    /* Show sub menu */
    /* ------------------------------ */

    $('.js_showSubMenu').on('click', function (e) {
        killclick(e);
        $(this).toggleClass('open');
        $(this).parents('.subMenu').find('.subMenuContent').toggleClass("active");
    });

    $(".js_closeSubMenu").click(function() {
        $(this).closest(".subMenuContent").removeClass("active");
        $(this).closest(".subMenu").find(".showSubMenu").removeClass("open");
    });

    /* ------------------------------ */
    /* Load News Articles */
    /* ------------------------------ */

    $('.js_newsListPage').on('click', 'a.newslistLink', function(e) {
        killclick(e);

        var category = $(this).data('category') || '',
            section_title = $(this).data('section-title') || '',
            tag = $(this).data('tag') || '',
            wrap_element = $('.newsArticles'),
            news_url = $(this).attr('href');

        wrap_element.html('');
        wrap_element.data('category', category);
        wrap_element.data('section-title', section_title);
        wrap_element.data('tag', tag);

        if (tag !== '') {
            tag = '?tag=' + tag;
            news_url = news_url.replace(tag, '');
        }

        loadNewsArticles();

        history.pushState('state', 'title', news_url + tag);

        $('.subMenuContent').removeClass("active");
        $('.js_showSubMenu').removeClass('open');
    });

    if ($('.newsArticles').length) {
        loadNewsArticles(true);
    }

    if ($('.relatedArticles').length) {
        loadNewsArticles(true);
    }

    $('.showMoreWrap .showMore').on('click', function (e) {
        killclick(e);

        if(!$(this).hasClass('loading')) {
            loadNewsArticles();
        }
    });

    /* ------------------------------ */
    /* Back to top link animation */
    /* ------------------------------ */

    $('a[href="#top"]').click(function () {
        $('html, body').animate({scrollTop: 0}, 'slow');
        return false;
    });

    /* ------------------------------ */
    /* Brand Info expanding content */
    /* ------------------------------ */

    if ($('.brandDescription').length) {

        $(document).on('click', '.brandDescription .readMore', function (e) {
            var $this = $(this);
            killclick(e);

            $this.parent().find('.desc').slideToggle();
            if ($this.text() === 'Read More +') {
                $this.text('Read Less -');
            } else {
                $this.text('Read More +');
            }
        });
    }

    /* -----------------------------
     *  fixing height in search on initial load
     -----------------------------*/
    if ($(window).width() > window.breakpoints.mobile) {
        $('.fixMyHeight').matchHeight();
    }

    /* -----------------------------
     *  mobile sidenav menu
     -----------------------------*/

    $('.js_sideNavTrigger').on('click', function() {
        $(this).toggleClass('open');
        $(this).next('.sideNavWrapper').slideToggle();
    })

    /* ------------------------------ */
    /* Tabs */
    /* ------------------------------ */

    // Hide Tab Content and add class of active to first tab

    $(".tabContent").hide();
    $(".tabContainer").each(function () {
        $(this).find('.tabContent').first().show();
    });

    // add class of active to first tab
    $('.tabs').each(function () {
        $('li', this).first().find('a').addClass('active');
    });

    $(".tabs li a").click(function (e) {

        e.preventDefault();

        var parent = $(this).parents('.tabs'),
            link = $(this).attr('href'),
            offset,
            off_top;

        offset = parent.prev().offset();
        off_top = offset.top + parseInt(parent.prev().height());

        $('#loadingOverlay').fadeIn(500);

        // show the active tab and hide all sibling tabs
        $(link).siblings('.tabContent').fadeOut(200, function () {
            $(link).fadeIn(200, function () {
                $('#loadingOverlay').fadeOut(500);

                $('body,html').stop(true, false).animate({
                    scrollTop: $('.tabContainer').offset().top - 80
                }, 800);

            });
        });

        // add and remove active class
        parent.find('a').removeClass('active');
        $(this).addClass('active'); // parents so you can add markup round the a tag if needed
    });

    if ($('.actionBlock').length > 0) {
        createWaypoint('#js_waypointTime', 250, '.actionBlock', '75%');

        setTimeout(function(){
            $('.actionBlock').matchHeight();
        }, 500);
    }

    $(".bannerWrap").waypoint(function (direction) {
        if(direction === 'down') {
            $('.tabs').addClass('fixed');
        } else {
            $('.tabs').removeClass('fixed');
        }
    }, {
        offset: function() {
            return -this.element.clientHeight
        }
    });

    /* ------------------------------ */
    /* Ajax Tabs */
    /* ------------------------------ */

    $(".tabMenuWrap li a").on('click', function(e) {
        killclick(e);

        var ajax_url,
            filename = $(this).attr("href"),
            page_id = 0,
            offset,
            off_top,
            first_click = false,
            title = $(this).text();

        filename = filename.replace("#", "");

        if ($(this).parents('ul').data('pageid') !== undefined) {
            page_id = $(this).parents('ul').data('pageid');
        }

        ajax_url =  $(this).parents('ul').data('url');

        if ($(this).hasClass('firstClick')) {
            $(this).removeClass('firstClick');
            first_click = true;
        }

        /* if this is not the first time then scroll to position  */
        if (!$(this).hasClass('active')) {

            if (first_click === false) {
                offset = $('.tabMenuWrap').prev().offset();
                off_top = offset.top + parseInt($('.tabMenuWrap').prev().height());
                $('#loadingOverlay').fadeIn(500);
            } else {
                off_top = 0
            }

            $('body,html').stop(true, false).animate({
                scrollTop: (off_top) - 10
            }, 800);

            $(".tabMenuWrap li a").removeClass('active');
            $(this).addClass('active');

            $.ajax({
                type: 'post',
                url: ajax_url,
                data: {
                    ajax: true,
                    selected: filename,
                    page_id: page_id,
                    title: title
                },
                success: function(response) {

                    $('#loadingOverlay').fadeOut(500);

                    $('.tabsContent .tabPane').html(response);

                    if ($('.galleryWrap li').length > 0) {
                        createWaypoint('.galleryWrap', 250, '.galleryWrap li', '75%');
                    }

                    if ($('.js_galleryOverlay').length > 0) {
                        $('.js_galleryOverlay').mtcOverlay({
                            gallery: true,
                            imageTitle: true,
                            contentClass: 'showOverflow',
                            video: true,
                            videoSettings: {
                                autoplay: false,
                                width: 800,
                                height: 450
                            },
                            buttonHtml: '<div class="videoCloseButton overlayCloseButton"><a href="#"><i class="fa fa-remove"></i> Close</a></div>'
                        });

                    }

                    if ($('.videoOverlay').length > 0) {
                        youTubeOverlay('.videoOverlay');
                    }

                    tabsFeaturedItemsCarousel();
                }
            });
        }
    });

    $('.tabMenuWrap li').first().find('a').addClass('firstClick').trigger('click');

    /* ------------------------------ */
    /* Mobile tabs menu */
    /* ------------------------------ */

    if($(window).width() < window.breakpoints.mobile) {
        $('.tabs h3').on('click', function() {
            $(this).parents('.wrapper').find('ul').slideToggle();
            $(this).toggleClass('open');
        })
    }

    /* ------------------------------ */
    /* Mobile sticky header menu */
    /* ------------------------------ */

    if($(window).width() < window.breakpoints.mobile) {

        if(!$('.stickyHeader').hasClass('itemPageStickyHeader')) {

            $('.stickyHeader h3').on('click', function() {
                $(this).parents('.wrapper').find('.linksWrap ul').slideToggle();
                $(this).toggleClass('open');
            })

            $('.linksWrap li').on('click', function() {
                $(this).parent('ul').slideUp();
                $(this).parents('.wrapper').find('h3').removeClass('open');
            })
        }
    }


    /* ------------------------------ */
    /* Mobile and tablet sticky header menu on FPA page*/
    /* ------------------------------ */

    if($(window).width() < window.breakpoints.tablet) {
        $('.itemPageStickyHeader h3').on('click', function() {
            $(this).parents('.wrapper').find('.linksWrap ul').slideToggle();
            $(this).toggleClass('open');
        })

        $('.linksWrap li').on('click', function() {
            $(this).parent('ul').slideUp();
            $(this).parents('.wrapper').find('h3').removeClass('open');
        })
    }

    /* ------------------------------ */
    /* Custom Scrollbars */
    /* ------------------------------ */

    if ($('.scrollPane').length) {
        $('.scrollPane').perfectScrollbar();
    }

    if ($('.overflowWrap').length && $(window).width() > window.breakpoints.mobile) {
        $('.overflowWrap').perfectScrollbar();
    }

    /* ------------------------------ */
    /* No HTML5 Validation */
    /* ------------------------------ */

    if ($('form').length) {
        $('form').attr('novalidate', 'novalidate');
    }

    /* ------------------------------ */
    /* Image Hover */
    /* ------------------------------ */

    $('.itemsList').on('mouseenter', 'li', function () {
        $(this).find('.hover').stop(true, true).fadeIn();
    });

    $('.itemsList').on('mouseleave', 'li', function () {
        $(this).find('.hover').stop(true, true).fadeOut();
    });

    /* ------------------------------ */
    /* MTC Zoom
     *
     * Provides gallery and zoom functions on item page
     *
     */

    if($(".zoom").length > 0) {
        $(".zoom").mtcZoom({
            enableGallery: true,
            displayLoading: true,
            hideMessageOnLaunch: true,
            message: 'Tap or mouseover to activate zoom<i class="fa fa-plus"></i>'
        });

    }

    /* ------------------------------ */
    /* MTC Overlay
     *
     * Allows links to open in an overlay above the window content
     *
     */


    if($('.mtcOverlay').length) {
        $('.mtcOverlay').mtcOverlay();
    }

    $('.addedToBasket').css('cursor', 'pointer').on('click', function () {
        var cacheThis = $(this);
        window.location = cacheThis.find('a').attr('href');
    });

    /* ------------------------------ */
    /* Prevent Zoom On Mobile Devices */
    /* ------------------------------ */

    if(windowWidth <= window.breakpoints.mobile) {
        viewportMeta.attr('content', 'width=device-width,initial-scale=1,maximum-scale=1');
    }

    /* ------------------------------ */
    /* File Upload Name */
    /* ------------------------------ */

    $('#fileUpload').on ('change', function() {
        var formelement = $(this);
        formelement.next('.fileName').html(formelement.val().replace('C:\\fakepath\\', ''));
    });

    /* ------------------------------ */
    /* Dropdown Navigation  */
    /* ------------------------------ */

    // HoverIntent - delay on dropdown
    if ($('.mainMenu .sub').length) {

        // $('.mainMenu > li').on('mouseenter', function () {
        //     if(windowWidth > window.breakpoints.mobile) {
        //         var $this = $(this);
        //         if($this.find('.sub').length) {
        //
        //             $this.addClass('showSub');
        //             $('.sub', this).stop(true, true).fadeIn(300);
        //         }
        //     }
        // }).on('mouseleave', function () {
        //     if(windowWidth > window.breakpoints.mobile) {
        //         $(this).removeClass('showSub');
        //         $('.sub', this).stop(true, true).fadeOut(300);
        //     }
        // });

        // console.log('window width' + windowWidth);

        // console.log('window breakpoint' + window.breakpoints.mobile);

        $('.mainMenu > li').hoverIntent({
            sensitivity: 10,
            interval: 80,
            over: function() {
                if(windowWidth > window.breakpoints.mobile) {
                    var $this = $(this);

                    if($this.find('.sub').length && !$this.parents('.slideOutMenu').length) {
                        $this.addClass('showSub');
                        $('.sub', this).stop(true, true).fadeIn(300);
                    }
                }
            },
            //timeout: 150,
            out: function() {
                if(windowWidth > window.breakpoints.mobile) {

                    if (!$(this).parents('.slideOutMenu').length) {
                        $(this).removeClass('showSub');
                        $('.sub', this).stop(true, true).fadeOut(300);
                    }
                }
            }
        });
    }

    /* -----------------------------
     *  display refine form
     -----------------------------*/

    $('body').find('.js_triggerRefine').on('click', function() {

        var speed = 0,
            only_scroll_to = false,
            $this = $(this),
            scroll_element = '';

        if ($('.mobileNavBlock').hasClass('fixed')) {
            speed = 800;

            if ($('.searchFilter').is(':visible')) {
                only_scroll_to = true;
            }
        }

        if ($.browser.safari) {
            scroll_element = $('body');
        } else {
            scroll_element = $('html');
        }

        // scroll to the top then show the form
        scroll_element.stop(true, false).animate({
            scrollTop: 0
        }, speed , function () {

            if (only_scroll_to === false) {
                $this.toggleClass('active');

                if ($('.js_offersMenuMobile').is(':visible')) {
                    $('.js_offersMenuMobile').slideUp(function () {
                        $('.js_mobileOffersTrigger').removeClass('active');
                        $('#search .searchFilter').slideToggle();
                    });
                } else {
                    $('.flyoutWrap').slideUp(function () {
                        $('.flyout').removeClass('alive');
                        $('.tabsNav ul li a').removeClass('active');
                        $('#search .searchFilter').slideToggle();
                    });
                }
            }
        });
    });

    /* -----------------------------
     *  Match Heights
     -----------------------------*/

    $('.js_fixHeight').matchHeight();
    $('.js_fixHeight .textWrap h3.offerTitle').matchHeight();
    $('.newsList li').matchHeight();
    $('.callToActions .contentBlock').matchHeight();

    $('.financeOptionsMobile, .priceSpecification').matchHeight();


    /* -----------------------------
     *  show info field
     -----------------------------*/

    $('.searchWrap').on('mouseenter', '.infoField', function() {
        if( $(this).find('.infoContent').length > 0 && windowWidth > window.breakpoints.mobile) {
            $(this).find('.infoContent').stop(true, true).fadeIn(500);
        }
    }).on('mouseleave', '.infoField', function(){
        $(this).find('.infoContent').stop(true, true).fadeOut(200);
    });

    /* -----------------------------
     *  display ad content mobile
     -----------------------------*/

    directionsMap();

    $('.js_mapDirections').on('click', function (e) {
        e.preventDefault();
        $(this).parents('.getDirections').find('form').slideToggle();
    });

    /* -----------------------------
     *  display ad content mobile
     -----------------------------*/

    $('.js_mobileShowBlock h2').on('click', function() {

        if(windowWidth <= window.breakpoints.mobile) {

            var $this = $(this),
                $parentBlock = $this.parent();

            $this.toggleClass('open');
            $parentBlock.find('.itemBlockContent').slideFadeToggle();
        }
    });

    /* -----------------------------
     *  Scroll to link
     -----------------------------*/

    $('body').on('click', '.js_scrollTo', function (e) {

        killclick(e);

        var offset,
            off_top,
            link_to,
            sticky_header_height = 0;

        link_to = $(this).attr('href');

        if($('body').find($(link_to)).length > 0) {

            if($('.siteInnerWrapper').find($('.historyNavigation')).length > 0 && windowWidth > window.breakpoints.mobile) {
                sticky_header_height = $('.siteInnerWrapper .historyNavigation').outerHeight();
            }

            if($('.siteInnerWrapper').find($('.historyNavigation')).length > 0 && windowWidth < window.breakpoints.mobile) {
                sticky_header_height = $('.siteInnerWrapper .historyNavTrigger').outerHeight();
            }

            if($('#content').find($('.stickyHeader')).length > 0) {
                sticky_header_height = $('#content .stickyHeader').outerHeight();
            }

            offset = $(link_to).offset();
            off_top = offset.top;

            $('body,html').stop(true, false).animate({

                scrollTop: (off_top - sticky_header_height) - 10
            }, 800);
        }
    });


    /* ----------------------------------- */
    /* Sticky header at n amount of pixels
    /* ----------------------------------- */

    $(document).scroll(function() {
        if($('.js_stickyHeader').length > 0) {
            var $element = $('.js_stickyHeader'),
                header_height = $('#header').height();
            if ($(document).scrollTop() >= header_height /*&& !is_touch_device()*/) {
                // user scrolled passed header
                $element.addClass('showMe');
            } else {
                $element.removeClass('showMe');
            }
        }
    });

    /* ----------------------------------- */
    /* Sticky navigation history at n amount of pixels
    /* ----------------------------------- */

    $(document).scroll(function() {
        if($('.js_stickyHistoryNav').length > 0) {
            var $element = $('.js_stickyHistoryNav'),
                header_height = ($('#header').height()) + ($('.keyMessageBanner').height()) + ($('.topFullBanner').height());
            if ($(document).scrollTop() >= header_height /*&& !is_touch_device()*/) {
                // user scrolled passed header
                $element.addClass('showMe');
            } else {
                $element.removeClass('showMe');
            }
        }
    });

    /* -----------------------------
     *  History nav on mobile
     -----------------------------*/
    $('.js_historyNavTrigger').on('click', function() {
        $(this).toggleClass('open');
        $(this).next('ul').slideToggle();
    })

    if(windowWidth < window.breakpoints.mobile) {
        $('.historyNavigation ul li').on('click', function() {
            $('.js_historyNavTrigger').removeClass('open');
            $(this).parent('ul').slideUp();
        })
    }

    /* -----------------------------
     *  Tabs
     -----------------------------*/

    $('.subMenu .tabWrap').mtcTabs({
        breakpoint: 0
    });

    /* -----------------------------
     *  Content sub menu sub show
     -----------------------------*/

    $('.js_parentLink').on('click', function(e) {
        killclick(e);
        $(this).toggleClass('open');
        $(this).parent().find('ul').slideToggle();
    });

    /* -----------------------------
     *  Show / Hide share options
     -----------------------------*/

    $(".js_showShareOptions").on('click', function(e) {
        killclick(e);
        addThisInit();
        $(this).parent().find(".addthis_toolbox").stop(true, true).fadeToggle();
        $(this).toggleClass('open');
    });

    if ($('.js_shareLanding').length) {
        addThisInit();
    }

    /* -----------------------------
     *  youtube video overlay
     -----------------------------*/

    financeVideoOverlay();

    $('.js_fuzzyVideoOverlay').mtcOverlay({
        contentClass: 'showOverflow',
        video: true,
        videoSettings: {
            autoplay: true,
            width: 800,
            height: 450
        },
        buttonHtml: '<div class="videoCloseButton overlayCloseButton"><a href="#"><i class="fa fa-remove"></i> Close</a></div>'
    });

    if ($('.js_landingGalleryTrigger').length) {
        $('.js_landingGalleryTrigger').mtcOverlay({
            gallery: true
        });
    }

    /* -----------------------------
     *  show search form when tab is clicked
     -----------------------------*/

    $('.js_showFormTab').on('click', function() {

        var search_form = $(this).parents('form'),
            position_amount = search_form.outerWidth() - 20;

        if($(this).hasClass('showForm')) {
            $(this).removeClass('showForm');
            $(this).parent('#searchForm').removeClass('showForm');
            $(this).parent('#searchForm').addClass('shakeForm');
        } else {
            $(this).addClass('showForm');
            $(this).parent('#searchForm').addClass('showForm');
            $(this).parent('#searchForm').removeClass('shakeForm');
            position_amount = 0;
        }

        search_form.animate({
            left: '-' + position_amount
        });
    });

    /* -----------------------------
     *  new car detail page
     *  when we hit the container let the magic happen
     -----------------------------*/

    createWaypoint('.galleryWrap', 250, '.galleryWrap li', '75%');

    createWaypoint('.fadeEachIn .gridRow', 250, '.gridRow .gridColumn', '75%');


    if($('.shareThisCar').length > 0 && windowWidth < window.breakpoints.mobile) {
        $('.shareThisCar .js_showShareOptions').trigger('click');
    }

    /* -----------------------------
     *  heritage pages fade in va va voom
     -----------------------------*/

    createWaypoint('.heritageWrapper', 350, '.heritageWrapper .section', '75%');

    createWaypoint('.listOfFeatures', 350, '.listOfFeatures .features li', '75%');

    createWaypoint('.listOfServices', 350, '.listOfServices .services li', '75%');

    createWaypoint('.listOfRestoration', 450, '.listOfRestoration .services li', '75%');

    createWaypoint('.packages', 450, '.packages .package', '75%');


    /* -----------------------------
     *  show select content on click
     -----------------------------*/

    $('.tabContent').each( function () {
        $(this).find('.contentToShow').hide().first().show();
    });

    $('.newVehicle .subMenuContent a').on('click', function (e) {
        e.preventDefault();

        var parent = $(this).parents('.withSubMenu'),
            link = $(this).attr('href'),
            $this = $(this);

        $('#loadingOverlay').fadeIn(500);

        // show the active tab and hide all sibling tabs
        $(link).siblings('.contentToShow').slideUp(600, function () {
            $(link).slideDown(800, function () {
                $('#loadingOverlay').fadeOut(400);
                $this.parents('.subMenuContent').addClass("active");
                $this.parents('.subMenuContent').find('.js_showSubMenu').removeClass('open');
            });
        });

        // add and remove active class
        parent.find('a').removeClass('active');
        $(this).addClass('active'); // parents so you can add markup round the a tag if needed
    });


    /* -----------------------------
     *  window resized and finished
     -----------------------------*/

    $(function () {
        'use strict';
        // Change this to the location of your server-side upload handler:
        var url =  '/sites/' + siteName + '/templates/ajax/file_uploader.php';

        $('#fileToUpload').fileupload({
            type: 'post',
            url: url,
            dataType: 'json',
            beforeSend: function (e, data) {
	            $('.fileUpload .nameOfFile').remove();
                $('.fileUpload .errorWrap').remove();
                $('.fileUpload .inputWrap').removeClass('inputError').removeClass('showError');
            },
            done: function (e, data) {
                $('#fileName').val('');

                if (data.result.success.message != '' && data.result.success.message != undefined) {
                    $('.fileUpload').append('<span class="nameOfFile">' + data.result.success.message + '</span>');
                    $('#fileName').val(data.result.success.message);
                }

                if (data.result.errors.message != '' && data.result.errors.message != undefined) {
                    $('.fileUpload .inputWrap').addClass('inputError').addClass('showError').append('<div class="errorWrap"><i class="fa fa-exclamation"></i><span>' + data.result.errors.message + '</span></div>');
                }
            },
            progressall: function (e, data) {
                var progress = parseInt(data.loaded / data.total * 100, 10);

                $('#progress .progress-bar').css(
                    'width',
                    progress + '%'
                );
            }
        }).prop('disabled', !$.support.fileInput)
            .parent().addClass($.support.fileInput ? undefined : 'disabled');
    });

    /* -----------------------------
     *  window resized and finished
     -----------------------------*/

    function resizedw() {

        // itemImages();

        if($('.map').length) {
            $('.map').attr('style', '');
        }

        if($('.searchWrap form').length) {
            $('.searchWrap form').attr('style', '');
        }

        if(windowWidth < window.breakpoints.mobile && $('.ps-active-y').length){
            $('.ps-active-y').removeClass('ps-active-y');
        }
    }

    keyMessageBannerScroller();

    $(window).resize(function() {

        //issue with iphone when scrolling - phone believes window has been resized
        if ($(window).width() !== windowWidth) {
            // Update the window width for next time
            windowWidth = $(window).width();

            //call resize function when window has finished resizing
            clearTimeout(finishedResizing);
            finishedResizing = setTimeout(resizedw, 300);
        }
    });

    /*
     * Featured links
     * kill a but let li handle toggles as an after needs to be able to "close" the box
     */

	$('.featuredLink').on('click',function (e) {
		e.preventDefault();
		$('.keyLinks, .homeFranchiseCTAs').toggleClass('subKeyActive');
        return false;
	});

		$('.js_emailSelect').on('change',function (e) {
	    if (this.checked || $('.js_callUnsubscribe').is(":checked")) {
		    $('#unsubscribeFormEmail').attr({'placeholder': 'Your email address*'});
	    } else {
		    $('#unsubscribeFormEmail').attr({'placeholder': 'Your email address'});
	    }
    });

    $('.js_textSelect').on('change',function (e) {
	    if (this.checked || $('.js_callUnsubscribe').is(":checked")) {
		    $('#unsubscribeFormMobile').attr({'placeholder': 'Your mobile number*'});
	    } else {
		    if (!$('.js_callSelect').is(":checked")) {
		    	$('#unsubscribeFormMobile').attr({'placeholder': 'Your mobile number'});
		    }
	    }
    });

	$('.js_callSelect').on('change',function (e) {
	    if (this.checked || $('.js_callUnsubscribe').is(":checked")) {
		    $('#unsubscribeFormMobile').attr({'placeholder': 'Your mobile number*'});
		    $('#unsubscribeFormTelephone').attr({'placeholder': 'Your telephone number*'});
	    } else {
		    if (!$('.js_textSelect').is(":checked")) {
		    	$('#unsubscribeFormMobile').attr({'placeholder': 'Your mobile number'});
		    }
		    $('#unsubscribeFormTelephone').attr({'placeholder': 'Your telephone number'});
	    }
    });

    $('.js_callUnsubscribe').on('change',function (e) {
	    if (this.checked) {
		    $('#unsubscribeFormEmail').attr({'placeholder': 'Your email address*'});
		    $('#unsubscribeFormMobile').attr({'placeholder': 'Your mobile number*'});
		    $('#unsubscribeFormTelephone').attr({'placeholder': 'Your telephone number*'});

		    $('#unsubscribeFormPostcode').attr({'placeholder': 'Your postcode*'});
	    } else {
		    if (!$('.js_emailSelect').is(":checked")) {
		    	$('#unsubscribeFormEmail').attr({'placeholder': 'Your email address'});
		    }
		    if (!$('.js_textSelect').is(":checked") && !$('.js_callSelect').is(":checked")) {
		    	$('#unsubscribeFormMobile').attr({'placeholder': 'Your mobile number'});
			}
			if (!$('.js_callSelect').is(":checked")) {
		    	$('#unsubscribeFormTelephone').attr({'placeholder': 'Your telephone number'});
			}

			if (!$('.js_postSelect').is(":checked")) {
		    	$('#unsubscribeFormPostcode').attr({'placeholder': 'Your postcode'});
			}
	    }
    });

    $('.js_postSelect').on('change',function (e) {
	    if (this.checked || $('.js_callUnsubscribe').is(":checked")) {
		    $('#unsubscribeFormPostcode').attr({'placeholder': 'Your postcode*'});
	    } else {
	    	$('#unsubscribeFormPostcode').attr({'placeholder': 'Your postcode'});
	    }
    });

    $('.js_personalisedFormOverlay').mtcOverlay({
        buttonHtml: '<div class="altCloseButton overlayCloseButton"><a href="#"><i class="fa fa-remove"></i> Close</a></div>'
    });

    $('.csFinanceWrap .financeCalculator, .csFinanceWrap .textWrap').matchHeight();

    $(document).on('click', '.keyFeatures .newItemTabTitle', function(e) {

        if (matchesMediaQuery(767)) {
            e.preventDefault();

            $(this).toggleClass('active');

            $('.keyFeatures').toggleClass('active');
        }
    })

    $('.promiseBlock li').matchHeight();

    $(document).on('change', '#switchView', function() {
        $('#switchView2').trigger('click');
    });

    $(document).on('change', '#switchView2', function() {
        $('#switchView').trigger('click');
    });

    $('.pageContent').fitVids();

    $('.js_pvfHistorySlider').on('init', function(event, slick) {
        var $this = $(this);
        $($(this).find('.slick-slide:not(.slick-cloned)')).each(function(index) {
            var year = $(this).data('year');

            setTimeout(function() {
                $('.js_pvfHistorySlider .slick-dots li:nth-child(' + (index + 1) + ') a').html(year);
            }, 100);
        });
    });

    $('.js_pvfHistorySlider').on('breakpoint', function(){
        var $this = $(this);
        $($(this).find('.slick-slide:not(.slick-cloned)')).each(function(index) {
            var year = $(this).data('year');

            $('.js_pvfHistorySlider .slick-dots li:nth-child(' + (index + 1) + ') a').html(year);
        });
    });


    $('.js_pvfHistorySlider').slick({
        dots: true,
        prevArrow: '<button type="button" class="slick-arrow slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
        nextArrow: '<button type="button" class="slick-arrow slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
        adaptiveHeight: true,
        customPaging: function(slick,index) {
            return '<a></a>';
        },
        responsive: [{
            breakpoint: 640,
            settings: {
                arrows: false
            }
        }]
    });

    const applyNav = $(".js_applyNav");

    if (applyNav.length > 0) {
        $(document).on('click', '.js_applyNav li a', function(e) {
            e.preventDefault();
            var index = $(this).parent().index();
            $('.js_applyNav li').removeClass('active');
            $(this).parent().addClass('active');
            $('.pvfApplyContent li').hide();
            $('.pvfApplyContent li:nth-child(' + (index + 1) + ')').show();
        });

        $('.js_applyNav li:first-child a').trigger('click');

        $('.js_applyPrev').on('click', function(e) {
            e.preventDefault();

            var index = $(this).data('id');
            $('.js_applyNav li:nth-child(' + (index - 1) + ') a').trigger('click');
        });

        $('.js_applyNext').on('click', function(e) {
            e.preventDefault();

            var index = $(this).data('id');
            $('.js_applyNav li:nth-child(' + (index + 1) + ') a').trigger('click');
        });
    }

    $('.js_accordionWrap .accordionTitle').on('click', function(e) {
        e.preventDefault();
        var $this = $(this);

        $this.parent().toggleClass('active');
        $this.next('.accordionContent').stop(true, true).slideFadeToggle();
    });

    // if sidebar exists
    if ($('.js_contentSidebar').length) {
        subNavActive();
    }

    // on click of sidebar title
    $('.js_contentSidebar .sidebarTitle').on('click', function (e) {
        e.preventDefault();

        if ($(this).parents('.js_contentSidebar').first().hasClass('activeSlideNav')) {
            $(this).next().stop(true, true).slideFadeToggle();
        }
    });

    $('a[href*="#"]').on('click', function(e) {
        var targetHref = $(this).attr("href");
        var firstChar = targetHref.charAt(0);

        if (!targetHref.includes("directions") && firstChar == '#') {
            e.preventDefault();

            $('html, body').animate({
                scrollTop: $(targetHref).offset().top,
            }, 500, 'linear');
        }
    });
}); // document ready

$(window).load(function () {
    "use strict";

    /* -----------------------------
     *  Mobile Chosen
     -----------------------------*/

    $(function () {
        $('.mobileChosen select').on('change',function () {
            $(this).parent().find('span').text($('option:selected',$(this)).text());
        });
    }());

    /* -----------------------------
     *  Fix heights
     -----------------------------*/

    //matchBlockHeight(".itemWrap .item", ".itemWrap .itemDescription");

    //$('.gridRow .gridColumn').matchHeight();

    $('.featuredItems div.reviewsBlock').each(function () {
        var this_parent_height = $(this).parents('li').outerHeight(),
            inner_title_height,
            content_height,
            paddingAmount;

        inner_title_height = $(this).find('.title').innerHeight();
        content_height = $(this).find('ul').outerHeight();

        paddingAmount = content_height + inner_title_height;
        paddingAmount =  (this_parent_height - paddingAmount) / 2 + 4; // 4 is for the border

        $(this).find('.title').css({
            paddingTop:  paddingAmount,
            paddingBottom:  paddingAmount
        });
    });

    /* -----------------------------
    * youtube iframe video
    -------------------------------- */

    $('.videoWrap').each(function () {
        var videoSrc = $(this).find('iframe').data('youtube');
        $(this).find('iframe').attr('src', videoSrc);
    });

/**
 * First Featured Offer
 */

if ($('.js_firstFeature').length && $('.fullLengthHighlightBox').find('li').length) {

    var firstOffer = $('.fullLengthHighlightBox').find('li').eq(0),
        firstOfferText = firstOffer.text();

    $('.js_firstFeature').text(firstOfferText);
    firstOffer.addClass('firstOffer');
}

const contactTab = $(".tabsContainer .js_tab");

if (contactTab.length > 0) {
    contactTab.click(function() {
        contactTab.removeClass("active");
        $(this).addClass("active");

        $(".contactContent").removeClass("active");
        $(".contactContent#" + $(this).data("id")).addClass("active");
    });
}

}); // window ready

$(window).resize(function () {

    "use strict";

});


$(window).on('resize', debouncer(function (e) {

    /* ------------------------------ */
    /* Force strict mode */
    /* ------------------------------ */

    "use strict";

    // if featuredItems exists
    if ($('.gridWrap .featuredItems li').length) {
        tabsFeaturedItemsCarousel();
    }

    responsiveLazyLoading();

    $('.financeOptionsMobile, .priceSpecification').matchHeight();

    keyMessageBannerScroller();

    pvFoundationLogosCarousel();

    awardsCarousel();

    mobileHomeSearchMove();

    paralaxImageChange();

    if ($(window).width() > window.breakpoints.mobile) {
        $('.hasFranchise').attr('style', '');
        $('.hasFranchise').find('.open').removeClass('open');
        $('.hasFranchise').find('.column ul').attr('style', '');
        $('.hasFranchise').find('.sub').attr('style', '');

        $('.js_offersMenuMobile').removeAttr('style');
        $('.js_mobileOffersTrigger').removeClass('active');
    }

    if($('.shareWrap').length > 0 && windowWidth > window.breakpoints.mobile) {
	    if (!$('.js_showShareOptions').hasClass('open')) {
        	$('.js_showShareOptions').trigger('click');
        }
    }

    if($('.shareThisCar').length > 0 && windowWidth < window.breakpoints.mobile) {
        if (!$('.shareThisCar .js_showShareOptions').hasClass('open')) {
        	$('.shareThisCar .js_showShareOptions').trigger('click');
        }
    }

    calculateFinance();

    carstoreSliders();

    // if sidebar exists
    if ($('.js_contentSidebar').length) {
        subNavActive();
    }

})); // window resize
